import PreviewDetailImg from 'assets/images/feature-slots/preview_detail.png';
import PreviewDListlImg from 'assets/images/feature-slots/preview_list.png';
import { SLOT_KEY } from './common';

const routes = [
    {
        matchRegex: '/Equipment/Detail/:id',
        name: 'Equipment - Detail',
        slots: [
            SLOT_KEY.SLOT_SECTION,
            SLOT_KEY.SLOT_V_STATIC_TABLE_COLUMN,
            SLOT_KEY.SLOT_SCRIPTS,
            SLOT_KEY.SLOT_V_TABLE_COLUMN,
            SLOT_KEY.SLOT_V_SECTION,

        ],
        image: PreviewDListlImg,
        parentKeys: {
            [SLOT_KEY.SLOT_SECTION]: [
                { key: 'equip-stock-unit', label: 'Equipment Stock Unit' },
            ],
            [SLOT_KEY.SLOT_V_STATIC_TABLE_COLUMN]: [
                { key: 'table-link-supplier-header', label: 'Table "Link supplier" header' },
                { key: 'table-link-supplier-body', label: 'Table "Link supplier" body' }
            ],
            [SLOT_KEY.SLOT_V_SECTION]: [
                { key: 'linked-supplier', label: 'Linked Supplier' },
            ],
        },
        options: {
            [SLOT_KEY.SLOT_SCRIPTS]: [
                { key: 'MARKETPLACE_EVENT_SUPPLIER_RATE_UPDATE', label: 'Supplier rate update' },
                { key: 'MARKETPLACE_EVENT_GET_SUPPLIER_SUCCESS', label: 'Get supplier success' },
            ],
        },
        replaceElements: {
            [SLOT_KEY.SLOT_SECTION]: [
                { key: 'equip-unit-element', label: 'Equipment Unit Element' },
            ],
        },
    },
    {
        matchRegex: '/Equipment/Create',
        name: 'Equipment - Create',
        slots: [
            SLOT_KEY.SLOT_SECTION,

        ],
        image: PreviewDListlImg,
        parentKeys: {
            [SLOT_KEY.SLOT_SECTION]: [
                { key: 'equip-stock-unit', label: 'Equipment Stock Unit' },
            ],
        },
        replaceElements: {
            [SLOT_KEY.SLOT_SECTION]: [
                { key: 'equip-unit-element', label: 'Equipment Unit Element' },
            ],
        },
    },
]

export default routes;